import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { MdIconComponent } from '@inditex/mduikit';
import { WINDOW } from '@ng-web-apis/common';
import { TranslateModule } from '@ngx-translate/core';

import { CommonWindow } from '@core/domain/models/common-window.model';

@Component({
    selector: 'paragraph-toggle',
    standalone: true,
    imports: [CommonModule, TranslateModule, MdIconComponent],
    templateUrl: './paragraph-toggle.component.html',
})
export class ParagraphToggleComponent {
    constructor(
        @Inject(WINDOW) private readonly window: CommonWindow,
    ) {}

    @Input() public textStyle = 'text-l';

    @Input() public content: string;

    @Input() public maxHeight: number;

    private readonly isPrerender: boolean = this.window.navigator.userAgent.toLowerCase().includes('prerender');

    public showFullDescription = !!this.isPrerender;

    public toggleDescription(): void {
        this.showFullDescription = !this.showFullDescription;
    }
}
